<template>
  <div class="another-ways">
    <div class="another-ways__title main-title">
      <h2>
        другие профильные направления
      </h2>
    </div>

    <div class="another-ways__cards">
      <div
        v-for="item of cardsList"
        :key="item.id"
        :class="['another-ways__card', item.className]"
      >
        <div>
          <h4>
            {{ item.cardTitle }}
          </h4>

          <p>
            {{ item.cardDescription }}
          </p>
        </div>

        <nuxt-link :to="item.cardLink">
          <span>
            перейти на страницу
          </span>
          <img
            src="/v2/school-new/another-ways/arrow.svg"
            alt="arrow"
          >
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolAnotherWays',
  data: () => ({
    physicalClassCard: {
      id: 1,
      cardTitle: 'физмат класс',
      cardDescription: 'изучайте физику, информатику и математику',
      cardLink: '/online-school/fiziko-matematicheskij',
      className: 'another-ways__card--blue',
    },
    languageClassCard: {
      id: 2,
      cardTitle: 'лингвистический класс',
      cardDescription: 'изучайте английский, немецкий, китайский, испанский, французский языки',
      cardLink: '/online-school/lingvisticheskij',
      className: 'another-ways__card--green',
    },
    humanitiesClassCard: {
      id: 3,
      cardTitle: 'гуманитарный класс',
      cardDescription: 'изучайте обществознание, русский язык, литературу',
      cardLink: '/online-school/gumanitarnyj',
      className: 'another-ways__card--orange',
    },
    socialEconomyClassCard: {
      id: 4,
      cardTitle: 'соц. эконом класс',
      cardDescription: 'изучайте обществознание, экономику, финансовую грамотность, предпринимательство',
      cardLink: '/online-school/socialno-ekonomicheskij',
      className: 'another-ways__card--red',
    },
  }),
  computed: {
    cardsList() {
      const routeName = this.$route.name;

      switch (routeName) {
        case 'online-school-fiziko-matematicheskij':
          return [
            this.languageClassCard,
            this.humanitiesClassCard,
            this.socialEconomyClassCard,
          ];
        case 'online-school-lingvisticheskij':
          return [
            this.physicalClassCard,
            this.humanitiesClassCard,
            this.socialEconomyClassCard,
          ];
        case 'online-school-gumanitarnyj':
          return [
            this.physicalClassCard,
            this.languageClassCard,
            this.socialEconomyClassCard,
          ];
        case 'online-school-socialno-ekonomicheskij':
          return [
            this.physicalClassCard,
            this.languageClassCard,
            this.humanitiesClassCard,
          ];
        default:
          return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.another-ways {
  &__title {
    margin-bottom: 2.5rem;
  }

  &__cards {
    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: calc(33.33% - (var(--scale) * 40) / 3);
    min-height: calc(var(--scale) * 316);
    padding: calc(var(--scale) * 24) calc(var(--scale) * 30);
    position: relative;

    background-color: #FFFFFF;
    background-size: cover;
    border-radius: calc(var(--scale) * 40);
    box-sizing: border-box;

    @include media-down($size-tablet) {
      width: calc(50% - (var(--scale) * 8) / 2);
      min-height: calc(var(--scale) * 180);
      padding: calc(var(--scale) * 22) calc(var(--scale) * 16);
      border-radius: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    &--green {
      background-image: url("/v2/school-new/another-ways/green.webp");
    }

    &--orange {
      background-image: url("/v2/school-new/another-ways/orange.webp");
    }

    &--red {
      background-image: url("/v2/school-new/another-ways/red.webp");
    }

    &--blue {
      background-image: url("/v2/school-new/another-ways/blue.webp");
    }

    h4 {
      font-family: 'Onest', sans-serif;
      font-weight: 500;
      font-size: calc(var(--scale) * 48);
      line-height: 110%;
      letter-spacing: -0.02em;
      color: $white-color;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 28);
        line-height: 95%;
      }

      @include media-down($size-mobile) {
        max-width: calc(var(--scale) * 306);
      }
    }

    p {
      margin-top: calc(var(--scale) * 8);

      font-family: 'Onest', sans-serif;
      font-weight: 400;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      color: $white-color;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 16);
        letter-spacing: -0.02em;
      }

      @include media-down($size-mobile) {
        max-width: calc(var(--scale) * 296);

        font-size: calc(var(--scale) * 18);
      }
    }

    a {
      display: flex;
      align-items: center;
      gap: calc(var(--scale) * 16);
      padding: calc(var(--scale) * 19) calc(var(--scale) * 32);

      border-radius: calc(var(--scale) * 24);
      border: calc(var(--scale) * 1) solid $white-color;
      box-shadow: 0 calc(var(--scale) * 5) calc(var(--scale) * 20) 0 rgba($white-color, .15) inset;
      background: rgba($white-color, .15);

      font-family: 'Onest', sans-serif;
      font-weight: 400;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: $white-color;

      transition: background-color .2s ease-out;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 9) calc(var(--scale) * 16);

        border-radius: calc(var(--scale) * 16);

        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        width: calc(var(--scale) * 42);
        height: calc(var(--scale) * 42);
        position: absolute;
        top: calc(var(--scale) * 16);
        right: calc(var(--scale) * 16);
      }

      &:hover {
        background: rgba($white-color, .35);
      }

      span {
        @include media-down($size-mobile) {
          display: none;
        }
      }
    }
  }
}
</style>
